export default "{\n    \"label\": \"{{name}}\",\n    \"label_0\": \"Status\",\n    \"label_plural\": \"{{count}} Statuses\"\n}\n"